import './App.css';
import './css/new-style.css';
import './all.css';
import { BrowserRouter, Route, Routes, Navigate, useParams, Outlet, useLocation } from 'react-router-dom';
import './languages/i18n';
import { HomePage } from './pages/home.tsx';
import { Why } from './pages/why.tsx';
// import { Pricing } from './pages/pricing.tsx';
import { SellFromAnywhere } from './pages/sell-from-anywhere.tsx';
import { ConnectAllChannel } from './pages/connect-all-channel.tsx';
import { AppointmentBooking } from './pages/appointment-booking.tsx';
import { AnalyticsInsights } from './pages/analytics-insigths.tsx';
// import { ParlaConnect } from './pages/parla-connect.tsx';
// import { ParlaBooking } from './pages/parla-booking.tsx';
// import { ParlaSuite } from './pages/parla-suite.tsx';
import { Payment } from './pages/payment.tsx';
import { FAQ } from './pages/faq.tsx';
import { Integrations } from './pages/integrations.tsx';
import { Partners } from './pages/partners.tsx';
import { Press } from './pages/press.tsx';
import { ContactUs } from './pages/contact.tsx';
import { NotFound } from './pages/404.tsx';
import { useEffect } from 'react';
import i18n from './languages/i18n';

function LeadinfoTracker() {
  useEffect(() => {
    (function (l, e, a, d, i, n, f, o) {
      if (!l[i]) {
        l.GlobalLeadinfoNamespace = l.GlobalLeadinfoNamespace || [];
        l.GlobalLeadinfoNamespace.push(i);
        l[i] = function () {
          (l[i].q = l[i].q || []).push(arguments);
        };
        l[i].t = l[i].t || n;
        l[i].q = l[i].q || [];

        o = e.createElement(a);
        f = e.getElementsByTagName(a)[0];
        o.async = true;
        o.src = d;
        f.parentNode.insertBefore(o, f);
      }
    })(
      window,
      document,
      'script',
      'https://cdn.leadinfo.net/ping.js',
      'leadinfo',
      'LI-6A392F21116AF'
    );
  }, []);

  return null;
}

function Routing() {
  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return (
    <div>
      <LeadinfoTracker />
      <Outlet />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root to English as the default language */}
        <Route path="/" element={<Navigate to="/en/home" replace />} />

        {/* Routes with language parameter */}
        <Route path=":lang" element={<Routing />} >
          <Route path="home" element={<HomePage />} />
          <Route path="why" element={<Why />} />
          {/* <Route path="pricing" element={<Pricing />} /> */}
          <Route path="sell-from-anywhere" element={<SellFromAnywhere />} />
          <Route path="connect-all-channel" element={<ConnectAllChannel />} />
          <Route path="appointment-booking" element={<AppointmentBooking />} />
          <Route path="analytics-insigths" element={<AnalyticsInsights />} />
          <Route path="payment" element={<Payment />} />
          {/* <Route path="parla-connect" element={<ParlaConnect />} />
          <Route path="parla-booking" element={<ParlaBooking />} />
          <Route path="parla-suite" element={<ParlaSuite />} /> */}
          <Route path="faq" element={<FAQ />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="partners" element={<Partners />} />
          <Route path="press" element={<Press />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
